export const formatTime = (timestamp) => {
    const now = new Date();
    const messageTime = new Date(timestamp);
    const diffInSeconds = Math.floor((now - messageTime) / 1000);

    if (diffInSeconds < 60) {
      return "Just now";
    }
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
    }
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    }
    const diffInDays = Math.floor(diffInHours / 24);
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    if (messageTime.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    }

    return messageTime.toLocaleDateString("en-US", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

export const formatUpworkDate = (date) => {
    const givenDate = new Date(date);
    const now = new Date();
  
    const isToday =
      givenDate.getDate() === now.getDate() &&
      givenDate.getMonth() === now.getMonth() &&
      givenDate.getFullYear() === now.getFullYear();
  
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday =
      givenDate.getDate() === yesterday.getDate() &&
      givenDate.getMonth() === yesterday.getMonth() &&
      givenDate.getFullYear() === yesterday.getFullYear();
  
    const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
  
    if (isToday) {
      return `Today at ${givenDate.toLocaleTimeString(undefined, timeOptions)}`;
    } else if (isYesterday) {
      return `Yesterday at ${givenDate.toLocaleTimeString(undefined, timeOptions)}`;
    } else {
      return givenDate.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }) + ` at ${givenDate.toLocaleTimeString(undefined, timeOptions)}`;
    }
  };
